import memoize from 'lodash/memoize';

import get from 'lodash/get';

import sanitizeImage from 'state/sanitizers/sanitizeImage';

import { CalloutColorMap } from 'constants/ColorScheme';

import { ArticleCallout } from 'types';

export default memoize((articleCallout: unknown): ArticleCallout | null => {
  const id = get(articleCallout, '_key');

  if (!id) {
    return null;
  }

  return {
    id,
    type: get(articleCallout, '_type', 'articleCallout'),
    color: CalloutColorMap[get(articleCallout, 'color', '#80aeff')] || 'BLUE',
    variant: get(articleCallout, 'variant', 'right'),
    infoSectionText: get(articleCallout, 'infoSectionText', []),
    supportingSectionIsActive: !get(
      articleCallout,
      'displayWithoutSupportingSection',
      false
    ),
    supportingSectionText: get(articleCallout, 'supportingSectionText', []),
    supportingSectionImage: sanitizeImage(
      get(articleCallout, 'supportingSectionImage.asset'),
      get(articleCallout, 'supportingSectionImage.alt')
    ),
    renderSupportingSectionWider: get(
      articleCallout,
      'renderSupportingSectionWider',
      false
    ),
  };
});
